import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

const FALLBACK = {
  primary: '#7C3AED',
  accent_warm: '#F97316',
  accent_cool: '#22C55E',
  ink: '#111827',
  gradient_end: '#A855F7',
};

export function useBranding() {
  return useQuery({
    queryKey: ['branding'],
    queryFn: async () => {
      const { data } = await api.get('/api/v1/tenants/branding/');
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

/** Apply branding tokens to <html> as CSS variables. */
export function useApplyBranding() {
  const { data } = useBranding();
  useEffect(() => {
    const branding = data?.branding ?? FALLBACK;
    const root = document.documentElement;
    root.style.setProperty('--brand-primary', branding.primary);
    root.style.setProperty('--brand-accent-warm', branding.accent_warm);
    root.style.setProperty('--brand-accent-cool', branding.accent_cool);
    root.style.setProperty('--brand-ink', branding.ink);
    root.style.setProperty('--brand-gradient-end', branding.gradient_end);
  }, [data]);
  return data;
}
